import { useEffect, useRef } from "preact/hooks";

import { Fragment } from "preact";
import { createPortal } from "preact/compat";

export function Tools1() {
	const canvasRef = useRef(null);
	const unitRef = useRef(null);
	const inchScaleRef = useRef(null);
	const inchScaleLabelRef = useRef(null);
	const inputXRef = useRef(null);
	const inputYRef = useRef(null);
	const setGuidesRef = useRef(null);
	const clearRef = useRef(null);
	const lockRef = useRef(null);
	const downloadRef = useRef(null);

	useEffect(() => {
		const canvas = canvasRef.current;
		const unitSelect = unitRef.current;
		const inchScaleSelect = inchScaleRef.current;
		const inchScaleLabel = inchScaleLabelRef.current;
		const inputX = inputXRef.current;
		const inputY = inputYRef.current;
		const setGuidesBtn = setGuidesRef.current;
		const clearBtn = clearRef.current;
		const lockBtn = lockRef.current;
		const downloadBtn = downloadRef.current;

		const ctx = canvas.getContext("2d");
		const dpi = window.devicePixelRatio || 1;

		let guideX = 100;
		let guideY = 160;
		let dragging = false;
		let isGuideLock = false;

		const dpiBase = +localStorage.getItem("dpiBase") || 96;

		function getUnitToPx(unit) {
			switch (unit) {
				case "cm":
					return (dpiBase / 2.54) * dpi;
				case "mm":
					return (dpiBase / 2.54) * dpi;
				case "in":
					return dpiBase * dpi;
			}
		}

		function setupCanvas() {
			const width = document
				.querySelector(".ruler-box")
				.getBoundingClientRect().width;
			const height = document
				.querySelector(".ruler-box")
				.getBoundingClientRect().height;
			canvas.style.width = width + "px";
			canvas.style.height = height + "px";
			canvas.width = width * dpi;
			canvas.height = height * dpi;
			ctx.setTransform(1, 0, 0, 1, 0, 0);
			ctx.scale(dpi, dpi);
			ctx.clearRect(0, 0, width, height);
			ctx.fillStyle = "white";
			ctx.fillRect(0, 0, canvas.width * 2, canvas.height * 2);
			ctx.fillStyle = "black";
		}

		function drawRulers(unit, inchScale = 16) {
			const unitPx = getUnitToPx(unit) / dpi;
			const divisions = unit === "in" ? inchScale : 10;
			const step = unitPx / divisions;
			const width = document
				.querySelector(".ruler-box")
				.getBoundingClientRect().width;
			const height =
				document.querySelector(".ruler-box").getBoundingClientRect().height -
				100;

			for (let i = 0; i < width / unitPx; i++) {
				const baseX = i * unitPx;
				for (let j = 0; j < divisions; j++) {
					let x = baseX + j * step;
					let h = 6;
					let label = "";

					if (unit === "in") {
						if (j % (divisions / 2) === 0) {
							h = 16;
							if (j === divisions / 2) label = "½";
						} else if (j % (divisions / 4) === 0) {
							h = 14;
							if (j === divisions / 4) label = "¼";
							else if (j === (divisions * 3) / 4) label = "¾";
						} else if (j % (divisions / 8) === 0) h = 12;
						else if (j % (divisions / 16) === 0) h = 10;
					} else if (j === 5) h = 12;

					ctx.beginPath();
					ctx.moveTo(x, 0);
					ctx.lineTo(x, h);
					ctx.stroke();

					if (label) {
						ctx.font = "10px sans-serif";
						ctx.textAlign = "center";
						ctx.fillText(label, x, h + 10);
					}
				}

				ctx.beginPath();
				ctx.moveTo(baseX + unitPx, 0);
				ctx.lineTo(baseX + unitPx, 20);
				ctx.stroke();
				ctx.font = "11px sans-serif";
				ctx.textAlign = "center";
				ctx.fillText(unit === "mm" ? (i + 1) * 10 : i + 1, baseX + unitPx, 32);
			}

			for (let i = 0; i < height / unitPx; i++) {
				const baseY = i * unitPx;
				for (let j = 0; j < divisions; j++) {
					let y = baseY + j * step;
					let w = 6;
					let label = "";

					if (unit === "in") {
						if (j % (divisions / 2) === 0) {
							w = 16;
							if (j === divisions / 2) label = "½";
						} else if (j % (divisions / 4) === 0) {
							w = 14;
							if (j === divisions / 4) label = "¼";
							else if (j === (divisions * 3) / 4) label = "¾";
						} else if (j % (divisions / 8) === 0) w = 12;
						else if (j % (divisions / 16) === 0) w = 10;
					} else if (j === 5) w = 12;

					ctx.beginPath();
					ctx.moveTo(0, y);
					ctx.lineTo(w, y);
					ctx.stroke();

					if (label) {
						ctx.font = "10px sans-serif";
						ctx.textAlign = "left";
						ctx.fillText(label, w + 2, y + 3);
					}
				}

				ctx.beginPath();
				ctx.moveTo(0, baseY + unitPx);
				ctx.lineTo(20, baseY + unitPx);
				ctx.stroke();
				ctx.font = "11px sans-serif";
				ctx.textAlign = "left";
				ctx.fillText(
					unit === "mm" ? (i + 1) * 10 : i + 1,
					24,
					baseY + unitPx + 3,
				);
			}

			if (guideX !== null) {
				ctx.strokeStyle = "red";
				ctx.beginPath();
				ctx.moveTo(guideX, 0);
				ctx.lineTo(guideX, height);
				ctx.stroke();
				const val =
					((guideX * dpi) / getUnitToPx(unit)) * (unit === "mm" ? 10 : 1);
				ctx.fillStyle = "red";
				ctx.fillText(`${val.toFixed(2)} ${unit}`, guideX + 4, 50);
				inputX.value = val.toFixed(2);
			} else {
				inputX.value = "";
			}

			if (guideY !== null) {
				ctx.strokeStyle = "red";
				ctx.beginPath();
				ctx.moveTo(0, guideY);
				ctx.lineTo(width, guideY);
				ctx.stroke();
				const val =
					((guideY * dpi) / getUnitToPx(unit)) * (unit === "mm" ? 10 : 1);
				ctx.fillStyle = "red";
				ctx.fillText(`${val.toFixed(2)} ${unit}`, 50, guideY - 4);
				inputY.value = val.toFixed(2);
			} else {
				inputY.value = "";
			}
		}

		function render() {
			const unit = unitSelect.value;
			const inchScale = parseInt(inchScaleSelect.value) || 16;
			inchScaleLabel.style.display = unit === "in" ? "inline" : "none";
			setupCanvas();
			drawRulers(unit, inchScale);
		}

		canvas.addEventListener("mousedown", (e) => {
			if (isGuideLock) return;
			dragging = true;
			guideX = e.offsetX;
			guideY = e.offsetY;
			render();
		});

		canvas.addEventListener("mousemove", (e) => {
			if (dragging) {
				guideX = e.offsetX;
				guideY = e.offsetY;
				render();
			}
		});

		canvas.addEventListener("mouseup", () => (dragging = false));
		canvas.addEventListener("mouseleave", () => (dragging = false));

		unitSelect.addEventListener("change", () => {
			render();
		});

		inchScaleSelect.addEventListener("change", render);
		window.addEventListener("resize", render);

		setGuidesBtn.addEventListener("click", () => {
			const width = document
				.querySelector(".ruler-box")
				.getBoundingClientRect().width;
			const height = document
				.querySelector(".ruler-box")
				.getBoundingClientRect().height;
			const unit = unitSelect.value;
			const pxPerUnit = getUnitToPx(unit);
			const xVal = parseFloat(inputX.value);
			const yVal = parseFloat(inputY.value);
			guideX =
				xVal >= 0 && !isNaN(xVal)
					? ((xVal / (unit === "mm" ? 10 : 1)) * pxPerUnit) / dpi
					: null;
			guideY =
				yVal >= 0 && !isNaN(yVal)
					? ((yVal / (unit === "mm" ? 10 : 1)) * pxPerUnit) / dpi
					: null;
			guideX = Math.max(0, Math.min(guideX, width - 1));
			guideY = Math.max(0, Math.min(guideY, height - 1));
			render();
		});

		clearBtn.addEventListener("click", () => {
			guideX = 100;
			guideY = 150;
			isGuideLock = false;
			render();
		});

		lockBtn.addEventListener("click", () => {
			isGuideLock = !isGuideLock;

			if (isGuideLock) {
				//unlock
				lockBtn.innerText = langText["text_ruler_unlock"];
			} else {
				//lock
				lockBtn.innerText = langText["text_ruler_lock"];
			}
		});

		downloadBtn.addEventListener("click", () => {
			const dataURL = canvas.toDataURL("image/png");

			const link = document.createElement("a");
			link.href = dataURL;
			link.download = "ruler-image.png";
			link.click();
		});

		render();

		return () => {
			window.removeEventListener("resize", render);
			unitSelect.removeEventListener("change", render);
			inchScaleSelect.removeEventListener("change", render);
		};
	}, []);

	return (
		<>
			<canvas ref={canvasRef}></canvas>
			{createPortal(
				<div class="controls" style={{ bottom: "30px", direction: "ltr" }}>
					<label>
						{langText["text_ruler_unit"]}:
						<select ref={unitRef}>
							<option value="cm">{langText["text_ruler_cm"]}</option>
							<option value="mm">{langText["text_ruler_mm"]}</option>
							<option value="in">{langText["text_ruler_in"]}</option>
						</select>
					</label>
					<label ref={inchScaleLabelRef} style={{ display: "none" }}>
						{langText["in_scale"]}
						<select ref={inchScaleRef}>
							<option value="2">1/2</option>
							<option value="4">1/4</option>
							<option value="8">1/8</option>
							<option value="16" selected>
								1/16
							</option>
							<option value="32">1/32</option>
						</select>
					</label>
					<div style={{ marginTop: "10px" }}>
						<label>
							X:
							<input type="number" ref={inputXRef} style={{ width: "60px" }} />
						</label>
						<label style={{ marginRight: "10px" }}>
							Y:
							<input type="number" ref={inputYRef} style={{ width: "60px" }} />
						</label>
						<button ref={setGuidesRef}>{langText["text_ruler_set"]}</button>
					</div>
					<div className="action" style={{ marginTop: "10px" }}>
						<button ref={clearRef}>{langText["text_ruler_clear"]}</button>
						<button ref={lockRef}>{langText["text_ruler_lock"]}</button>
						<button ref={downloadRef}>
							{langText["text_ruler_download_iamge"]}
						</button>
					</div>
				</div>,
				document.getElementById("ruler-controller"),
			)}
		</>
	);
}
